var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { attrs: { type: "card" } }, [
    _c(
      "div",
      { attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "card-title" }, [_vm._v("业务配置")]),
        _vm._v(" "),
        _c("el-input", {
          staticStyle: { width: "200px", "margin-right": "10px" },
          attrs: { size: "small", placeholder: "请输入关键字" },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.search($event)
            },
          },
          model: {
            value: _vm.listQuery.keywords,
            callback: function ($$v) {
              _vm.$set(_vm.listQuery, "keywords", $$v)
            },
            expression: "listQuery.keywords",
          },
        }),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: { click: _vm.search },
          },
          [_vm._v("查询")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: { click: _vm.handleCreateCfg },
          },
          [_vm._v("添加")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: { data: _vm.records, stripe: "", border: "" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "cfgGroup", label: "配置分组", width: "120" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "cfgGroupName", label: "分组名称", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("cfgGroupDisplay")(row.cfgGroup))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "cfgKey", label: "配置编码", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", [_vm._v(_vm._s(row.cfgKey))]),
                      _vm._v(" "),
                      row.cfgGroup !== "cus_cfg"
                        ? [
                            _c("el-divider", {
                              attrs: { direction: "vertical" },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("cfgKeyDisplayName")(row.cfgKey))
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "cfgValue", label: "配置值", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", [_vm._v(_vm._s(row.cfgValue))]),
                      _vm._v(" "),
                      row.cfgGroup !== "cus_cfg"
                        ? [
                            _c("el-divider", {
                              attrs: { direction: "vertical" },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("cfgValueDisplayName")(row.cfgValue)
                                )
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "remarks", label: "备注", width: "140" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_c("span", [_vm._v(_vm._s(row.remarks))])]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "createTime", label: "创建时间", width: "140" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("parseTime")(
                              row.createTime,
                              "{y}-{m}-{d} {h}:{i}"
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleEditCfg(row)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-drawer",
          {
            attrs: {
              title: "编辑配置",
              visible: _vm.dialogVisible,
              wrapperClosable: false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "busCfgForm",
                attrs: { model: _vm.busCfgForm, "label-width": "100px" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "配置分组", prop: "cfgGroup" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择配置分组", size: "small" },
                        on: { change: _vm.changeCfgGroup },
                        model: {
                          value: _vm.busCfgForm.cfgGroup,
                          callback: function ($$v) {
                            _vm.$set(_vm.busCfgForm, "cfgGroup", $$v)
                          },
                          expression: "busCfgForm.cfgGroup",
                        },
                      },
                      _vm._l(_vm.comboboxList, function (item) {
                        return _c("el-option", {
                          key: item.code,
                          attrs: { label: item.desc, value: item.code },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "配置key", prop: "cfgKey" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "70%" },
                      attrs: {
                        disabled: _vm.busCfgForm.cfgGroup !== "cus_cfg",
                        size: "small",
                        placeholder: "请输入配置编码",
                      },
                      scopedSlots: _vm._u(
                        [
                          _vm.busCfgForm.cfgGroup !== "cus_cfg"
                            ? {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.cfgKeyDisplayName)),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.busCfgForm.cfgKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.busCfgForm, "cfgKey", $$v)
                        },
                        expression: "busCfgForm.cfgKey",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "配置描述", prop: "cfgValue" } },
                  [
                    _vm.busCfgForm.cfgGroup === "sso_cfg"
                      ? _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择对象存储",
                              size: "small",
                            },
                            model: {
                              value: _vm.busCfgForm.cfgValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.busCfgForm, "cfgValue", $$v)
                              },
                              expression: "busCfgForm.cfgValue",
                            },
                          },
                          _vm._l(_vm.sso_type, function (item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: { label: item.desc, value: item.code },
                            })
                          }),
                          1
                        )
                      : _vm.busCfgForm.cfgGroup === "oss_cfg"
                      ? _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择单点登录配置",
                              size: "small",
                            },
                            model: {
                              value: _vm.busCfgForm.cfgValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.busCfgForm, "cfgValue", $$v)
                              },
                              expression: "busCfgForm.cfgValue",
                            },
                          },
                          _vm._l(_vm.oss_type, function (item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: { label: item.desc, value: item.code },
                            })
                          }),
                          1
                        )
                      : _c("el-input", {
                          attrs: { size: "small", placeholder: "请输入配置值" },
                          model: {
                            value: _vm.busCfgForm.cfgValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.busCfgForm, "cfgValue", $$v)
                            },
                            expression: "busCfgForm.cfgValue",
                          },
                        }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "备注", prop: "remarks" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 2,
                        size: "small",
                        placeholder: "请输入备注说明",
                        maxlength: "50",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.busCfgForm.remarks,
                        callback: function ($$v) {
                          _vm.$set(_vm.busCfgForm, "remarks", $$v)
                        },
                        expression: "busCfgForm.remarks",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.saveOrUpdate },
                      },
                      [_vm._v("确 定")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "small" },
                        on: {
                          click: function ($event) {
                            _vm.dialogVisible = false
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }